
<template>
    <div>
    <el-dialog title="员工详情" @close="close" width="430px" :visible.sync="dialogFormVisible">
        <el-row class="info_box">
            <el-col :span="24" style="text-align: center;">
                <img :src="avatar" style="width: 80px;border-radius: 50%;">
            </el-col>
            <el-col :span="24" style="margin-left: 130px;">员工姓名 : {{name}}</el-col>
            <el-col :span="24" style="margin-left: 130px;">手机号码 : {{phone}}</el-col>
            <el-col :span="24" style="margin-left: 130px;">所属部门 : {{deptName}}</el-col>
          <el-col :span="24" style="margin-left: 130px;">管理角色 : {{isAdminRole}}</el-col>
            <el-col :span="24" style="margin-left: 130px;">身份状态 : {{company(companyAuthStatus)}}/{{iscompanystate(status)}}</el-col>
            <el-col :span="24" style="margin-left: 130px;" v-if="coldderail != false">加入时间 : {{createtime}}</el-col>
            <el-col :span="24" style="margin-left: 130px;" v-if="coldderail == false">申请理由 : {{applyInfo.tips}}</el-col>
            <el-col :span="24" style="margin-left: 130px;" v-if="coldderail == false">申请时间 : {{applyInfo.createTime}}</el-col>
            <el-col :span="24" style="margin-left: 130px;" v-if="coldderail == false">来源 : {{applyInfo.source}}</el-col>
        </el-row>
        <div slot="footer" class="dialog-footer">
            <el-button class="filter-item" size="mini" @click="agreecompamy" type="primary" icon="el-icon-circle-close-outline" v-if="coldderail == false">同意
            </el-button>
            <el-button class="filter-item" size="mini" @click="noagreecompamy" type="primary" icon="el-icon-circle-check-outline"  v-if="coldderail == false">拒绝
            </el-button>
            <el-button class="filter-item" size="mini" @click="editemployee" type="primary" icon="el-icon-edit-outline">编辑
            </el-button>
           <!--  <el-button class="filter-item" size="mini" @click="close" type="primary" icon="el-icon-circle-check-outline">返回
            </el-button> -->
        </div>
    </el-dialog>
     <personedit ref="childedit" @refresh="refresh"></personedit>
    </div>
</template>
<script>
    import {stop,getpersonnel} from '@/api/admin/workerUser'
    import {addcompany} from '@/api/admin/user'
    import {getImgLink} from '@/config/env'
    import {mapGetters} from 'vuex'
    import {dataday} from '@/util/dateT'
    import {objKeySort } from '@/util/ajaxsign'
    import personedit from './personedit.vue'
    export default {
          components: {personedit},
        data() {
            return {
                userId : '',
                dialogFormVisible : false,
                coldderail : true,
                dictionarylist : [],
                avatar : '',
                deptName : '',
                name : '',
                phone : '',
                status : '',
                isAdminRole:'',
                createtime : '',
                companyAuthStatus : '',
                applyInfo:{}
            }
        },
        created() {},
        mounted() {
          this.init()
        },
        methods: {
          init(){
            this.applyInfo={
              tips:'',
              source:'',
              createTime:''
            }
          },
            //刷新列表操作
            refresh(){
                this.getCompanyInfo();
                this.$emit('refresh');
            },
            //设置展示
            setsataus(userId,infodetail){
              let that =this
                that.dialogFormVisible = true;
                that.userId = userId;
                let _infodetail=infodetail
                that.infodetail = infodetail;
                if(_infodetail.addCompanyLog){
                  that.applyInfo.tips=_infodetail.addCompanyLog.addTips?_infodetail.addCompanyLog.addTips:''
                  that.applyInfo.createTime=dataday(_infodetail.addCompanyLog.createDate)
                  if(_infodetail.addCompanyLog.source==1){
                    that.applyInfo.source='搜索企业信息加入'
                  }else{
                    that.applyInfo.source="由"+_infodetail.addCompanyLog.inviteUserName+"邀请加入"
                  }
                }
                that.getCompanyInfo(infodetail);
            },

            //编辑员工
            editemployee(){
                this.$refs.childedit.setsataus(this.userId,'编辑员工');
            },

            //项目详情数据请求
            getCompanyInfo(){
                getpersonnel(objKeySort({userId:this.userId})).then(response => {
                    this.avatar = response.data.data.avatar?getImgLink(response.data.data.avatar):(response.data.data.headimgurl?response.data.data.headimgurl:'/img/default-avatar.png');
                    this.deptName = response.data.data.deptName?response.data.data.deptName:'未设置';
                    this.name =  response.data.data.name;
                    this.phone =  response.data.data.phone;
                    this.status = response.data.data.status;
                    this.createtime = dataday(response.data.data.createtime);
                    this.isAdminRole = response.data.data.isAdminRole==1?"是":"否";

                    this.companyAuthStatus = response.data.data.companyAuthStatus
                    if(this.companyAuthStatus==1 || this.companyAuthStatus==-1){
                        this.coldderail = true;
                    }else{
                        this.coldderail = false;
                    }
                })
            },

            //默认时间
            settime(data){
                return dateOnce(data)
            },

              //同意加入
            agreecompamy(){
                addcompany(objKeySort({userId:this.userId,state : 1})).then(response =>{
                    this.refresh()
                })
            },

            //拒绝加入
            noagreecompamy(){
                addcompany(objKeySort({userId:this.userId,state : 0})).then(response =>{
                    this.refresh()
                })
            },
            //取消回调
            close(){
               this.dialogFormVisible = false;
            },

            iscompanystate(data){
                console.log(data);
                if(data ==1){
                    return '正常'
                }else if(data ==2){
                    return '冻结'
                }else if(data ==3){
                    return '删除'
                }
            },
            company(data){
                if(data == 1){
                     return  '员工'
                }else if(data == -1){
                     return  '被拒绝'
                }else{
                     return  '申请加入'
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
.container{
    min-width:800px;
    max-width:900px;
}
.form_layout_items{
    display:flex
}
.select_option{
    position: absolute;
    z-index: 22;
    width: 150px !important;
    right: 0;
    top: 0;
}
.el-table ::v-deep .el-table__row:nth-child(even) {
    background-color: #F6F9FF !important;
  }
  .form_layout_item{
      width:50%;
      border:1px solid #fff;
      height:80px;
  }
</style>
